import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=81988aa0&scoped=true&"
import script from "./PropertyView.vue?vue&type=script&lang=js&"
export * from "./PropertyView.vue?vue&type=script&lang=js&"
import style0 from "./PropertyView.vue?vue&type=style&index=0&id=81988aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81988aa0",
  null
  
)

export default component.exports